<template>
  <div class="order-list">
    <el-card class="query-card">
      <el-form :model="HistoryTraderRecordReqVo" ref="queryForm" label-width="auto" size="small" inline>

        <div class="query-grid">


          <el-form-item
              :label="$t('initUnTradeRecordPage.timetype2')"
              prop="time"
              class="full-row"
          >
            <el-select
                v-model="HistoryTraderRecordReqVo.time"

                filterable
                style="width: 500px;"
            >
              <el-option
                  v-for="item in timeList"
                  :key="item.domianName"
                  :label="item.displayName"
                  :value="item.domianName"
              />
            </el-select>
          </el-form-item>



          <el-form-item :label="$t('initTradeRecordPage.startDate')" prop="startDate">
            <el-date-picker
                style="width:210px"
                v-model="HistoryTraderRecordReqVo.startDate"
                type="datetime"

                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                popper-class="no-now-btn"

                :picker-options="startDatePickerOptions"
                :clearable="false"
                :editable="false"
            />
          </el-form-item>



          <el-form-item :label="$t('initTradeRecordPage.endDate')" prop="endDate">
            <el-date-picker
                style="width:210px"
                v-model="HistoryTraderRecordReqVo.endDate"
                type="datetime"

                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                popper-class="no-now-btn"

                :picker-options="endDatePickerOptions"
                :clearable="false"
                :editable="false"
            />
          </el-form-item>



          <el-form-item :label="$t('initTradeRecordPage.randomOrderno')" prop="trNos">
            <div class="input-with-more">
              <el-input v-model="HistoryTraderRecordReqVo.trNos"  clearable />
              <el-button type="text" @click="openMoreDialog('trNos')">More</el-button>
            </div>
          </el-form-item>




          <!--支付状态-->
          <el-form-item
              :label="$t('initTradeRecordPage.paymentState')"
              prop="trStatus"
          >
            <el-select
                v-model="HistoryTraderRecordReqVo.trStatus"

                clearable
                filterable
                style="width: 100%;"
            >
              <el-option
                  :label="$t('initTradeRecordPage.noConfirm')"
                  value="-2"
              />
              <el-option
                  :label="$t('initTradeRecordPage.noProcess')"
                  value="-1"
              />
              <el-option
                  :label="$t('initTradeRecordPage.fail')"
                  value="0"
              />
              <el-option
                  :label="$t('initTradeRecordPage.success')"
                  value="1"
              />
            </el-select>
          </el-form-item>


          <!--       时间类型 -->
          <el-form-item
              :label="$t('initTradeRecordPage.TimeType')"
              prop="dateType"
          >
            <el-select
                v-model="HistoryTraderRecordReqVo.dateType"


                filterable
                style="width: 100%;"
            >
              <el-option
                  :label="$t('initTradeRecordPage.tradeTime')"
                  value="0"
              />
              <el-option
                  :label="$t('initTradeRecordPage.comfirmDate')"
                  value="1"
              />
            </el-select>
          </el-form-item>



          <el-form-item :label="$t('initTradeRecordPage.businessOrderno')" prop="trMerOrderno">
            <div class="input-with-more">
              <el-input v-model="HistoryTraderRecordReqVo.trMerOrderno"  clearable />
            </div>
          </el-form-item>


          <!--冻结状态-->
          <el-form-item
              :label="$t('initTradeRecordPage.freezeState')"
              prop="trCongeal"
          >
            <el-select
                v-model="HistoryTraderRecordReqVo.trCongeal"

                clearable
                filterable
                style="width: 100%;"
            >
              <el-option
                  :label="$t('initTradeRecordPage.freezeState1')"
                  value="0"
              />
              <el-option
                  :label="$t('initTradeRecordPage.freezeState2')"
                  value="1"
              />
            </el-select>
          </el-form-item>


          <!--退款状态-->
          <el-form-item
              :label="$t('initTradeRecordPage.drawbackState')"
              prop="trRefundment"
          >
            <el-select
                v-model="HistoryTraderRecordReqVo.trRefundment"

                clearable
                filterable
                style="width: 100%;"
            >
              <el-option
                  :label="$t('initTradeRecordPage.noDrawback')"
                  value="0"
              />
              <el-option
                  :label="$t('initTradeRecordPage.okDrawback')"
                  value="1"
              />
            </el-select>
          </el-form-item>


          <el-form-item :label="$t('initTradeRecordPage.tradingURL')" prop="tradingURL">
            <div class="input-with-more">
              <el-input v-model="HistoryTraderRecordReqVo.tradingURL"  clearable />
            </div>
          </el-form-item>


          <!--     拒付状态   -->
          <el-form-item
              :label="$t('initTradeRecordPage.refusalPaymentState')"
              prop="trProtest"
          >
            <el-select
                v-model="HistoryTraderRecordReqVo.trProtest"

                clearable
                filterable
                style="width: 100%;"
            >
              <el-option
                  :label="$t('initTradeRecordPage.noRefusalPayment')"
                  value="0"
              />
              <el-option
                  :label="$t('initTradeRecordPage.okRefusalPayment')"
                  value="1"
              />
            </el-select>
          </el-form-item>


          <!--交易划款状态-->
          <el-form-item
              :label="$t('initTradeRecordPage.appropriationState')"
              prop="trTsStatus"
          >
            <el-select
                v-model="HistoryTraderRecordReqVo.trTsStatus"
                clearable
                filterable
                style="width: 100%;"
            >
              <el-option
                  :label="$t('initTradeRecordPage.notAppropriation')"
                  value="0"
              />
              <el-option
                  :label="$t('initTradeRecordPage.okMakeTable')"
                  value="1"
              />
              <el-option
                  :label="$t('initTradeRecordPage.okAppropriation')"
                  value="2"
              />
            </el-select>
          </el-form-item>



          <el-form-item :label="$t('initTradeRecordPage.email')" prop="email">
            <div class="input-with-more">
              <el-input v-model="HistoryTraderRecordReqVo.email"  clearable />
            </div>
          </el-form-item>


          <!--拒付状态-->
          <el-form-item
              :label="$t('initTradeRecordPage.trRsStatus')"
              prop="trRsStatus"
          >
            <el-select
                v-model="HistoryTraderRecordReqVo.trRsStatus"
                clearable
                filterable
                style="width: 100%;"
            >
              <el-option
                  :label="$t('initTradeRecordPage.notAppropriation')"
                  value="0"
              />
              <el-option
                  :label="$t('initTradeRecordPage.okMakeTable')"
                  value="1"
              />
              <el-option
                  :label="$t('initTradeRecordPage.okAppropriation')"
                  value="2"
              />
            </el-select>
          </el-form-item>







          <!--卡号前六位-->
          <el-form-item :label="`${$t('initTradeRecordPage.cardNum')}${ $t('initTradeRecordPage.firstSix') }`" prop="cardSix">
            <div class="input-with-more">
              <el-input v-model="HistoryTraderRecordReqVo.cardSix"  clearable maxlength="6"/>
            </div>
          </el-form-item>


          <el-form-item :label="`${$t('initTradeRecordPage.cardNum')}${ $t('initTradeRecordPage.afterFour') }`" prop="cardFour">
            <div class="input-with-more">
              <el-input v-model="HistoryTraderRecordReqVo.cardFour"  clearable maxlength="4"/>
            </div>
          </el-form-item>


          <!--申诉状态-->
          <el-form-item
              :label="$t('initTradeRecordPage.trIsexplain')"
              prop="trIsexplain"
          >
            <el-select
                v-model="HistoryTraderRecordReqVo.trIsexplain"
                clearable
                filterable
                style="width: 100%;"
            >
              <el-option
                  :label="$t('initTradeRecordPage.noexplain')"
                  value=-2
              />
              <el-option
                  :label="$t('initTradeRecordPage.explaing')"
                  value=-1
              />
              <el-option
                  :label="$t('initTradeRecordPage.failed')"
                  value=0
              />
              <el-option
                  :label="$t('initTradeRecordPage.success')"
                  value=1
              />
            </el-select>
          </el-form-item>






          <el-form-item
              :label="$t('initTradeRecordPage.Pre_authorization')"
              prop="trAuthType"
          >
            <el-select
                v-model="HistoryTraderRecordReqVo.trAuthType"
                clearable
                filterable
                style="width: 100%;"
            >
              <el-option
                  :label="$t('initTradeRecordPage.yes')"
                  value="1"
              />
              <el-option
                  :label="$t('initTradeRecordPage.no')"
                  value="0"
              />

            </el-select>
          </el-form-item>



          <!--     ip地址   -->
          <el-form-item :label="$t('initTradeRecordPage.ipAddress')" prop="ip">
            <div class="input-with-more">
              <el-input v-model="HistoryTraderRecordReqVo.ip"  clearable />
            </div>
          </el-form-item>


          <!--妥投状态-->
          <el-form-item
              :label="$t('initTradeRecordPage.toutouState')"
              prop="trDelivery"
          >
            <el-select
                v-model="HistoryTraderRecordReqVo.trDelivery"
                clearable
                filterable
                style="width: 100%;"
            >
              <el-option
                  :label="$t('initTradeRecordPage.tuotouState0')"
                  value="0"
              />
              <el-option
                  :label="$t('initTradeRecordPage.tuotouState1')"
                  value="1"
              />

            </el-select>
          </el-form-item>


          <!--是否上传单据-->
          <el-form-item
              :label="$t('initTradeRecordPage.uploaded')"
              prop="uploaded"
          >
            <el-select
                v-model="HistoryTraderRecordReqVo.uploaded"
                clearable
                filterable
                style="width: 100%;"
            >
              <el-option
                  :label="$t('initTradeRecordPage.no')"
                  value="0"
              />
              <el-option
                  :label="$t('initTradeRecordPage.yes')"
                  value="1"
              />

            </el-select>
          </el-form-item>



          <!--网关交易号-->

          <el-form-item
              :label="$t('initUnTradeRecordPage.gatewayNo')"
              prop="trGwNo"
          >
            <el-select
                v-model="HistoryTraderRecordReqVo.trGwNo"

                clearable
                filterable
                style="width: 100%;"
            >
              <el-option
                  v-for="item in gatewayList"
                  :key="item.gwNo"
                  :label="item.gwNo1"
                  :value="item.gwNo"
              />
            </el-select>
          </el-form-item>






<!--          <el-form-item class="btn-row" label-width="0">
            <el-button type="primary" @click="handleSearch">{{ $t('query') }}</el-button>
            <el-button @click="handleReset">{{ $t('reset') }}</el-button>
          </el-form-item>-->

        </div>
        <div class="btn-row">
          <el-button type="primary" @click="handleSearch">{{ $t('query') }}</el-button>

          <el-button @click="handleReset">{{ $t('reset') }}</el-button>
        </div>


        <!-- 通用 More 弹窗（只保留一个）  :title="getDialogTitle" -->
        <el-dialog
            :visible.sync="moreDialogVisible"
            width="800px"
            @close="onMoreDialogClose"
        >
          <el-input
              type="textarea"
              :rows="8"
              v-model="moreInput"
              :placeholder="$t('multipleValues')"
          />
          <span slot="footer">
    <el-button @click="closeMoreDialog">{{$t('cancel')}}</el-button>
    <el-button type="primary" @click="confirmMoreInput">{{$t('sure')}}</el-button>
  </span>
        </el-dialog>
      </el-form>

    </el-card>

    <div class="action-toolbar">
      <el-button
          v-if="hasPermission( 'merTradeMgr/initHistTradeRecordPage','downExcel')"
          :disabled="!hasSearched"
          :loading="downloadLoading"
          @click="handledownload"
          type="primary"
          icon="el-icon-download"
      >
        {{$t('button.download')}}
      </el-button>

      <el-drawer
          :visible.sync="detailVisible"
          direction="rtl"
          size="60%"
          :destroy-on-close="true"
      >
        <div slot="title">
          {{$t('initTradeRecordPage.orderdetial')}}
        </div>
        <trade-detail
            v-if="detailVisible"
            :tr-no="currentTrNo"
        />
      </el-drawer>

      <el-button
          v-if="hasPermission( 'merTradeMgr/initHistTradeRecordPage','look_detial')"
          :disabled="!currentRow"
          @click="showDetail"
          type="primary"
      >
        {{$t('button.detail')}}
      </el-button>



      <el-button
          v-if="hasPermission( 'merTradeMgr/initHistTradeRecordPage','upload_bills')"
          @click="uploadBills"
          type="primary"
          icon="el-icon-plus"
      >
        {{$t('button.logistics')}}
      </el-button>


      <el-button
          v-if="hasPermission( 'merTradeMgr/initHistTradeRecordPage','button_batchupload')"
          type="primary"
          icon="el-icon-upload2"
          @click="uploadDialogVisible = true"

      >
        <!--        批量上传-->
        {{$t('button.batchUpload')}}
      </el-button>



    </div>

    <div class="summary-container" v-if="hasSearched">
      <el-row :gutter="20">

        <el-col :xs="24" :sm="12" :md="6" :lg="isShowCny === 1 ? 4 : 6">
          <div class="summary-card">
            <div class="card-label">{{$t('initTradeRecordPage.successTradeAmt')}}</div>
            <div class="card-value">{{ summaryData.successCount }} <span class="unit">笔</span></div>
          </div>
        </el-col>

        <el-col :xs="24" :sm="12" :md="6" :lg="isShowCny === 1 ? 4 : 6">
          <div class="summary-card">
            <div class="card-label">{{$t('initTradeRecordPage.b_t_s_amt')}}</div>
            <div class="card-value text-warning-main">{{ summaryData.reserveAmountStr }}</div>
          </div>
        </el-col>

        <el-col :xs="24" :sm="12" :md="6" :lg="isShowCny === 1 ? 4 : 6">
          <div class="summary-card">
            <div class="card-label">{{$t($t('initTradeRecordPage.t_amt'))}}</div>
            <div class="card-value">{{ summaryData.totalAmountStr }}</div>
          </div>
        </el-col>

        <el-col :xs="24" :sm="12" :md="6" :lg="isShowCny === 1 ? 4 : 6">
          <div class="summary-card">
            <div class="card-label">{{$t('initTradeRecordPage.t_s_amt')}}</div>
            <div class="card-value text-success-main">{{ summaryData.successAmountStr }}</div>
          </div>
        </el-col>

        <el-col :xs="24" :sm="24" :md="24" :lg="24" v-if="isShowCny === 1">
          <div class="summary-card cny-card">
            <div class="card-label">{{$t('initTradeRecordPage.cny_amt')}}</div>
            <div class="card-value">
              {{ totMap.cny_amt || '0.00' }}
              <span class="sub-value">
            (
            <span class="text-success">{{ totMap.cny_s_amt || '0.00' }}</span>
            /
            <span class="text-danger">{{ totMap.cny_f_amt || '0.00' }}</span>
            )
          </span>
            </div>
          </div>
        </el-col>


      </el-row>
    </div>



    <el-card class="table-card" style="margin-top: 16px; overflow-x: auto;">
      <el-table :data="tableData" @sort-change="handleSortChange" border style="width: 100%" v-loading="loading" show-overflow-tooltip
                :cell-style="{whiteSpace: 'nowrap'}"
                :header-cell-style="{whiteSpace: 'nowrap'}"
      >

        <el-table-column

            width="120" align="center" :label="$t('choose')">
          <template slot-scope="scope">
            <el-radio
                v-model="selectedRowId"
                :label="scope.row.trNo"
                @change="handleRadioChange(scope.row)"
            >
              {{''}}
            </el-radio>
          </template>
        </el-table-column>

        <el-table-column prop="gwNo1" :label="$t('initTradeRecordPage.gatewayNo')" width="210"></el-table-column>
        <el-table-column prop="trNo" :label="$t('initTradeRecordPage.randomOrderno')" sortable="custom" width="250"></el-table-column>
        <el-table-column prop="trMerOrderno" :label="$t('initTradeRecordPage.businessOrderno')" width="250"></el-table-column>

        <!--      交易金额  -->
        <el-table-column  prop="trAmount" :label="$t('initTradeRecordPage.tradeMoney')" sortable="custom" :min-width="columnWidths.tradeMoney">
          <template #default="scope">
            <span>{{ scope.row.trCurrency }} {{ formatMoney(scope.row.trAmount) }}</span>
          </template>
        </el-table-column>

        <!--    人民币金额    -->
        <el-table-column
            :label="$t('initTradeRecordPage.cny_amout')"
            :min-width="columnWidths.cny_amout"
            v-if="isShowCny === 1"
            align="right"
            min-width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.trCnyAmount != null">
              CNY&nbsp;&nbsp;{{ formatMoney(scope.row.trCnyAmount) }}
            </span>
          </template>
        </el-table-column>

        <!--   保证金     -->
        <el-table-column :label="$t('initTradeRecordPage.protectMoney')" :min-width="columnWidths.protectMoney">
          <template #default="scope">
            <span>{{ scope.row.trCurrency }} {{ formatMoney(scope.row.trResever) }}</span>
          </template>
        </el-table-column>
        <!--  支付状态      -->
        <el-table-column :label="$t('initTradeRecordPage.paymentState')" :min-width="columnWidths.paymentState">
          <template slot-scope="scope">
            <div :title="`${scope.row.trBankCode || ''}  ${scope.row.tempInfo || ''}`">

              <span v-if="scope.row.trStatus === -2">{{$t('initTradeRecordPage.tradeState1')}}</span>

              <span v-else-if="scope.row.trStatus === -1">{{$t('initTradeRecordPage.tradeState2')}}</span>

              <span v-else-if="scope.row.trStatus === 0" style="color: red;">{{$t('initTradeRecordPage.tradeState3')}}</span>

              <span v-else-if="scope.row.trStatus === 1">{{$t('initTradeRecordPage.tradeState4')}}</span>

            </div>
          </template>
        </el-table-column>
        <!--   返回信息     -->
        <el-table-column prop="trBankinfo" :label="$t('initTradeRecordPage.backinfo')" :min-width="columnWidths.backinfo"></el-table-column>

        <!--      交易划款状态  -->
        <el-table-column  :label="$t('initTradeRecordPage.appropriationState')" :min-width="columnWidths.appropriationState">
          <template slot-scope="scope">
            <span v-if="scope.row.trTsStatus === 0">{{$t('initTradeRecordPage.appropriationState1')}}</span>

            <span v-else-if="scope.row.trTsStatus === 1">{{$t('initTradeRecordPage.appropriationState2')}}</span>

            <span v-else-if="scope.row.trTsStatus === 2" >{{$t('initTradeRecordPage.appropriationState3')}}</span>

          </template>
        </el-table-column>

        <!--      保证金划款状态  -->
        <el-table-column  :label="$t('initTradeRecordPage.trRsStatus')" :min-width="columnWidths.trRsStatus">
          <template slot-scope="scope">
            <span v-if="scope.row.trRsStatus === 0">{{$t('initTradeRecordPage.appropriationState1')}}</span>

            <span v-else-if="scope.row.trRsStatus === 1">{{$t('initTradeRecordPage.appropriationState2')}}</span>

            <span v-else-if="scope.row.trRsStatus === 2" >{{$t('initTradeRecordPage.appropriationState3')}}</span>

          </template>
        </el-table-column>

        <!--   是否退款     -->
        <el-table-column  :label="$t('initTradeRecordPage.isOrNotDrawback')" :min-width="columnWidths.isOrNotDrawback">
          <template slot-scope="scope">
            <span v-if="scope.row.trRefundment === 0">{{$t('initTradeRecordPage.no')}}</span>
            <span v-else-if="scope.row.trRefundment === 1" style="color: red;">{{$t('initTradeRecordPage.yes')}}</span>

          </template>
        </el-table-column>

        <!--   退款金额     -->
        <el-table-column  :label="$t('initTradeRecordPage.refualamout')" :min-width="columnWidths.refualamout">
          <template #default="scope">
            <span>{{ scope.row.trCurrency }} {{ formatMoney(scope.row.trRefundmentAmount) }}</span>
          </template>
        </el-table-column>

        <!--  是否拒付      -->
        <el-table-column :label="$t('initTradeRecordPage.isOrNotRefusalPayment')" width="120">
          <template slot-scope="scope">
                <span v-if="scope.row.trProtest === 1 || (scope.row.trCongeal === 0 && scope.row.trRefChaProFlag === 1)">

                  <span style="color: red;">{{$t('initTradeRecordPage.yes')}}</span>

                  <span v-if="scope.row.trRefChaProFlag === 1" style="color: red;">{{$t('initTradeRecordPage.refchapro')}}</span>

                </span>

            <span v-else-if="scope.row.trProtest === 0">
                  {{$t('initTradeRecordPage.no')}}
                </span>

          </template>
        </el-table-column>
        <!--      拒付金额  -->
        <el-table-column  :label="$t('initTradeRecordPage.protestamout')" :min-width="columnWidths.protestamout">
          <template slot-scope="scope">
            <span>{{ scope.row.trCurrency }} {{ formatMoney(scope.row.trProtestAmount) }}</span>
          </template>
        </el-table-column>


        <!--        是否冻结-->
        <el-table-column prop="trCongeal" :label="$t('initTradeRecordPage.isOrNotFreeze')" :min-width="columnWidths.isOrNotFreeze">
          <template slot-scope="scope">
            <span v-if="scope.row.trCongeal === 0">{{$t('initTradeRecordPage.no')}}</span>
            <span v-else-if="scope.row.trCongeal === 1" style="color: red;">{{$t('initTradeRecordPage.yes')}}</span>

          </template>
        </el-table-column>

        <!--    冻结金额    -->
        <el-table-column  :label="$t('initTradeRecordPage.congealamout')" :min-width="columnWidths.congealamout">
          <template slot-scope="scope">
            <span>{{ scope.row.trCurrency }} {{ formatMoney(scope.row.trCongealAmount) }}</span>
          </template>
        </el-table-column>

        <!--     申诉状态   -->
        <el-table-column  :label="$t('initTradeRecordPage.expStatus')" :min-width="columnWidths.expStatus">
          <template slot-scope="scope">
            <span v-if="scope.row.trIsexplain === -2">{{$t('initTradeRecordPage.noexplain')}}</span>

            <span v-else-if="scope.row.trIsexplain === -1">{{$t('initTradeRecordPage.explaing')}}</span>

            <span v-else-if="scope.row.trIsexplain === 0" >{{$t('initTradeRecordPage.failed')}}</span>
            <span v-else-if="scope.row.trIsexplain === 1" >{{$t('initTradeRecordPage.success')}}</span>

          </template>
        </el-table-column>

        <!--       是否上传单据 -->
        <el-table-column  :label="$t('initTradeRecordPage.uploaded')" :min-width="columnWidths.uploaded">
          <template slot-scope="scope">

            <span v-if="scope.row.merUploadtype === '1'" >{{$t('initTradeRecordPage.yes')}}</span>
            <span v-else-if="scope.row.merUploadtype === '0'" >{{$t('initTradeRecordPage.no')}}</span>

          </template>
        </el-table-column>
        <!--    是否预授权    -->
        <el-table-column prop="trAuthType" :label="$t('initTradeRecordPage.Pre_authorization')" :min-width="columnWidths.Pre_authorization">
          <template slot-scope="scope">


            <span v-if="scope.row.trAuthType === 0">{{$t('initTradeRecordPage.no')}}</span>

            <span v-else-if="scope.row.trAuthType == null"></span>

            <div v-else style="color: red;">{{$t('initTradeRecordPage.yes')}}</div>

          </template>
        </el-table-column>
        <!--  交易时间      -->
        <el-table-column prop="tradeDatetime" :label="$t('initTradeRecordPage.tradeTime')" width="250"></el-table-column>
        <!--     确认时间   -->
        <el-table-column prop="trAuthOpTime" :label="$t('initTradeRecordPage.comfirmDate')" :min-width="columnWidths.comfirmDate"></el-table-column>

        <!--  邮箱      -->
        <el-table-column prop="ciEmail" :label="$t('initTradeRecordPage.email')" :min-width="columnWidths.email"></el-table-column>

        <!--    IP地址    -->
        <el-table-column prop="ciIpaddress" :label="$t('initTradeRecordPage.ipAddress')" :min-width="columnWidths.ipAddress"></el-table-column>
        <!--    发卡行    -->
        <el-table-column prop="ciIssuingbank" :label="$t('initTradeRecordPage.ciIssuingbank')" :min-width="columnWidths.ciIssuingbank"></el-table-column>
        <!--    支付方式    -->
        <el-table-column  :label="$t('initTradeRecordPage.Payment')" :min-width="columnWidths.Payment">
          <template #default="scope">
            <span>{{ scope.row.pmName }}{{ scope.row.ciCardnopart }}</span>
          </template>
        </el-table-column>


        <!--  是否跳转      -->
        <el-table-column  :label="$t('initTradeRecordPage.whetherRedirect')" :min-width="columnWidths.whetherRedirect">
          <template slot-scope="scope">
            <span v-if="scope.row.ciUnionpayPaytype === 'RED'">{{$t('initTradeRecordPage.yes')}}</span>

            <div v-else >{{$t('initTradeRecordPage.no')}}</div>
          </template>
        </el-table-column>

        <!--        <el-table-column label="交易金额" width="100">
                  <template #default="scope">
                    <span>{{ scope.row.utr_currency }} {{ scope.row.utr_amount }}</span>
                  </template>
                </el-table-column>-->

      </el-table>

      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50]"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          style="margin-top: 16px; text-align: right;"
      />
    </el-card>

    <!--上传窗口-->
    <el-dialog
        :title="$t('initTradeRecordPage.batchUploadTitle')"
        :visible.sync="uploadDialogVisible"
        @close="handleDialogClose"
        width="600px">

      <el-alert
          :title="$t('initTradeRecordPage.downloadTip')"
          type="info"
          :closable="false">
      </el-alert>

      <div style="margin-top:20px">

        <el-button
            type="success"
            icon="el-icon-download"
            @click="downloadTemplate">

          <!--          下载模板-->
          {{$t('initTradeRecordPage.downloadTemplate')}}
        </el-button>

      </div>

      <div style="margin-top:30px">

        <el-upload
            ref="excelUpload"
            action=""
            :auto-upload="false"
            :show-file-list="true"
            :limit="1"
            accept=".xls,.xlsx"
            :on-change="handleFileChange">

          <el-button
              type="primary"
              icon="el-icon-folder-opened">

            <!--            选择Excel-->
            {{$t('initTradeRecordPage.selectExcel')}}

          </el-button>

        </el-upload>

      </div>

      <span slot="footer">

        <el-button @click="uploadDialogVisible=false">

             {{$t('cancel')}}

        </el-button>

        <el-button
            type="primary"
            @click="submitExcel">

<!--            开始上传-->
          {{$t('initTradeRecordPage.startUpload')}}

        </el-button>

    </span>

    </el-dialog>


    <!--物流-->
    <el-dialog
        :title="$t('initTradeRecordPage.modifyTitle')"
        :visible.sync="dialogVisible"
        width="620px"
        class="upload-dialog"
    >

      <el-form
          :model="billsData"
          label-width="90px"
          class="upload-form"
      >

        <el-form-item :label="$t('initTradeRecordPage.orderNo')">
          <span class="order-no">{{ billsData.tbTrNo }}</span>
        </el-form-item>

        <el-form-item :label="$t('initTradeRecordPage.trackingNo')">
          <el-input
              v-model="billsData.tbTrackingno"

          />
        </el-form-item>

        <el-form-item :label="$t('initTradeRecordPage.logisticsWebsite')">
          <el-input
              v-model="billsData.tbLogisticsWebsite"
          />
        </el-form-item>

        <el-form-item :label="$t('initTradeRecordPage.remark')">
          <el-input
              type="textarea"
              :rows="4"
              v-model="billsData.tbRemark"
          />
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">
          {{$t('cancel')}}
        </el-button>

        <el-button
            type="primary"
            @click="submitUpload"
        >
          {{$t('sure')}}
        </el-button>
      </div>

    </el-dialog>


    <!--详细信息-->
    <el-drawer
        :visible.sync="detailVisible"
        direction="rtl"
        size="60%"
        :destroy-on-close="true"
    >
      <div slot="title">
        {{$t('initTradeRecordPage.orderdetial')}}
      </div>

      <div style="padding: 0 20px;">

        <el-descriptions :column="2" border :label-style="commonLabelStyle" :content-style="commonContentStyle">

          <el-descriptions-item :span="2" label="" class-name="section-title-row">
            <div class="section-title">
              {{$t('initTradeRecordPage.transactionDetials')}}
            </div>
          </el-descriptions-item>

          <!--流水订单号-->
          <el-descriptions-item :label="$t('initTradeRecordPage.randomOrderno')">{{ CurrentDetailsRespVo.trNo }}</el-descriptions-item>
          <!--    商户订单号      -->
          <el-descriptions-item :label="$t('initTradeRecordPage.businessOrderno')">{{ CurrentDetailsRespVo.trMerOrderno }}</el-descriptions-item>
          <!--    跟踪单号      -->
          <el-descriptions-item :label="$t('initTradeRecordPage.trackingno')">{{ CurrentDetailsRespVo.tbTrackingno }}</el-descriptions-item>
          <!--      网关接入号    -->
          <el-descriptions-item :label="$t('initTradeRecordPage.gatewayNo')">{{ CurrentDetailsRespVo.trGwNo }}</el-descriptions-item>
          <!--      物流网站    -->
          <el-descriptions-item :label="$t('initTradeRecordPage.tbLogisticsWebsite')">{{ CurrentDetailsRespVo.tbLogisticsWebsite }}</el-descriptions-item>
          <el-descriptions-item :label="$t('initTradeRecordPage.tradeTime')">{{ CurrentDetailsRespVo.trDatetime }}</el-descriptions-item>

          <!--    保证金      -->
          <el-descriptions-item :label="$t('initTradeRecordPage.protectMoney')">{{ CurrentDetailsRespVo.trResever }}</el-descriptions-item>
          <!--      订单金额    -->
          <el-descriptions-item :label="$t('initTradeRecordPage.trAmout')">{{ CurrentDetailsRespVo.trAmount }}</el-descriptions-item>

          <!--      支付信息    -->
          <el-descriptions-item :label="$t('initTradeRecordPage.payinfo')">{{ CurrentDetailsRespVo.tempInfo }}</el-descriptions-item>
          <!--     支付状态     -->
          <el-descriptions-item :label="$t('initTradeRecordPage.paymentState')">
            <el-tag  size="small" v-if="CurrentDetailsRespVo.trStatus === 1">{{this.$t('initTradeRecordPage.tradeState4')}}</el-tag>
            <el-tag  size="small" v-else-if="CurrentDetailsRespVo.trStatus === -2">{{this.$t('initTradeRecordPage.tradeState1')}}</el-tag>
            <el-tag  size="small" v-else-if="CurrentDetailsRespVo.trStatus === -1">{{this.$t('initTradeRecordPage.tradeState2')}}</el-tag>
            <el-tag  size="small" v-else-if="CurrentDetailsRespVo.trStatus === 0">{{this.$t('initTradeRecordPage.tradeState3')}}</el-tag>

            <span v-else>{{ CurrentDetailsRespVo.trStatus || $t('statusUnknown') }}</span>
          </el-descriptions-item>

          <!--     交易划款状态     -->
          <el-descriptions-item :label="$t('initTradeRecordPage.appropriationState')">
            <el-tag  size="small" v-if="CurrentDetailsRespVo.trTsStatus === '0'">{{this.$t('initTradeRecordPage.appropriationState1')}}</el-tag>
            <el-tag  size="small" v-else-if="CurrentDetailsRespVo.trTsStatus === '1'">{{this.$t('initTradeRecordPage.appropriationState2')}}</el-tag>
            <el-tag  size="small" v-else-if="CurrentDetailsRespVo.trTsStatus === '2'">{{this.$t('initTradeRecordPage.appropriationState3')}}</el-tag>
            <span v-else>{{ CurrentDetailsRespVo.trTsStatus || $t('statusUnknown') }}</span>
          </el-descriptions-item>
          <!--      交易网址    -->
          <el-descriptions-item :label="$t('initTradeRecordPage.tradeurl')">{{ CurrentDetailsRespVo.trSubmiturl }}</el-descriptions-item>

          <!--     客户IP     -->
          <el-descriptions-item :label="$t('initTradeRecordPage.custIp')">{{ CurrentDetailsRespVo.ciIpaddress }}</el-descriptions-item>
          <!--     支付方式     -->
          <el-descriptions-item :label="$t('initTradeRecordPage.Payment')">{{ CurrentDetailsRespVo.pmName }}</el-descriptions-item>
          <el-descriptions-item :label="$t('initTradeRecordPage.Payment')">
            <template v-if="CurrentDetailsRespVo.pmId === 1">
              <img v-if="CurrentDetailsRespVo.trCardtype === 1" :src="'@/assets/pub/pay/images/visa.png'" alt="Visa" class="pay-icon"/>
              <img v-else-if="CurrentDetailsRespVo.trCardtype === 2" :src="'@/assets/pub/pay/images/master.png'" alt="master" class="pay-icon"/>
              <img v-else-if="CurrentDetailsRespVo.trCardtype === 3" :src="'@/assets/pub/pay/images/jcb.gif'" alt="JCB" class="pay-icon"/>
              <img v-else-if="CurrentDetailsRespVo.trCardtype === 4" :src="'@/assets/pub/pay/images/ae.jpg'" alt="American Express" class="pay-icon"/>
              <span>{{ CurrentDetailsRespVo.cardNum }}</span>
            </template>

            <span v-else>{{ CurrentDetailsRespVo.pmName }}</span>
          </el-descriptions-item>

          <!--       是否显示渣打   -->
          <!--          <el-descriptions-item label="是否显示渣打"  v-if="merDisplayScb == 1">{{ CurrentDetailsRespVo.pmName }}</el-descriptions-item>


                    <el-descriptions-item label="商户IP">{{ CurrentDetailsRespVo.ciMerIpaddress }}</el-descriptions-item>
                    <el-descriptions-item label="返回地址">{{ CurrentDetailsRespVo.trReturnurl }}</el-descriptions-item>-->
          <!--    商户ip      -->
          <el-descriptions-item :label="$t('initTradeRecordPage.merIp')">{{ CurrentDetailsRespVo.ciMerIpaddress }}</el-descriptions-item>

          <template v-if="merDisplayScb == 1">
            <el-descriptions-item label="RRN Number">{{ CurrentDetailsRespVo.trReference }}</el-descriptions-item>
            <el-descriptions-item label="Authorization Code">{{ CurrentDetailsRespVo.trAuthorizeld }}</el-descriptions-item>
            <el-descriptions-item label="Invoice Number">{{ CurrentDetailsRespVo.trBatchno }}</el-descriptions-item>
            <el-descriptions-item label="ECI">{{ CurrentDetailsRespVo.scbSecuritylevel }}</el-descriptions-item>
            <el-descriptions-item label="MID">{{ CurrentDetailsRespVo.scMid }}</el-descriptions-item>
          </template>
          <template v-else>
            <!--     返回地址       -->
            <el-descriptions-item :label="$t('initTradeRecordPage.returnurl')">{{ CurrentDetailsRespVo.trReturnurl }}</el-descriptions-item>
          </template>

          <!--     划款批次号    -->
          <el-descriptions-item :label="$t('initTradeRecordPage.trTsId')">{{ CurrentDetailsRespVo.trTsId }}</el-descriptions-item>
          <!--     划款类型     -->
          <el-descriptions-item :label="$t('initTradeRecordPage.tsType')">
            <el-tag  size="small" v-if="CurrentDetailsRespVo.tsType === '1'">{{this.$t('initTradeRecordPage.tsType1')}}</el-tag>
            <el-tag  size="small" v-else-if="CurrentDetailsRespVo.tsType === '2'"></el-tag>
            <span v-else>{{ CurrentDetailsRespVo.tsType || $t('unknownStatus') }}</span>
          </el-descriptions-item>

          <!--     支付币种     -->
          <el-descriptions-item :label="$t('initTradeRecordPage.payCurrncy')">{{ CurrentDetailsRespVo.trCurrency }}</el-descriptions-item>
          <!--      交易扣率    -->
          <el-descriptions-item :label="$t('initTradeRecordPage.tradeDeductRate')">{{ CurrentDetailsRespVo.trTradeRate }}</el-descriptions-item>

          <!--    单笔手续费币种      -->
          <el-descriptions-item :label="$t('initTradeRecordPage.onePoundageCurrncy')">{{ CurrentDetailsRespVo.trSppCurrency }}</el-descriptions-item>
          <!--       单笔手续费   -->
          <el-descriptions-item :label="$t('initTradeRecordPage.onePoundage')">{{ CurrentDetailsRespVo.trSpp }}</el-descriptions-item>

          <!--    保证金扣率      -->
          <el-descriptions-item :label="$t('initTradeRecordPage.guaranteeMoneyDeductRate')">{{ CurrentDetailsRespVo.trReseverRate }}</el-descriptions-item>
          <!--        划款币种  -->
          <el-descriptions-item :label="$t('initTradeRecordPage.appropriationCurrncy')">{{ CurrentDetailsRespVo.trSettCurrency }}</el-descriptions-item>

          <!--       划款汇率   -->
          <el-descriptions-item :label="$t('initTradeRecordPage.appropriationExchangeRate')">{{ CurrentDetailsRespVo.trSettRate }}</el-descriptions-item>
          <!--      退款状态    -->
          <el-descriptions-item :label="$t('initTradeRecordPage.drawbackState')">

            <el-tag  size="small" v-if="CurrentDetailsRespVo.trRefundment === 0">{{this.$t('initTradeRecordPage.noDrawback')}}</el-tag>
            <el-tag  size="small" v-else-if="CurrentDetailsRespVo.trRefundment === 1">{{this.$t('initTradeRecordPage.okDrawback')}}</el-tag>
            <span v-else>{{ CurrentDetailsRespVo.trRefundment || $t('unknownStatus') }}</span>
          </el-descriptions-item>

          <!--      退款金额    -->
          <el-descriptions-item :label="$t('initTradeRecordPage.refualamout')">{{ CurrentDetailsRespVo.trRefundmentAmount }}</el-descriptions-item>
          <!--      拒付状态    -->
          <el-descriptions-item :label="$t('initTradeRecordPage.refusalPaymentState')">
            <!--            {{ CurrentDetailsRespVo.trProtest }}-->
            <el-tag  size="small" v-if="CurrentDetailsRespVo.trProtest === 0">{{this.$t('initTradeRecordPage.noRefusalPayment')}}</el-tag>
            <el-tag  size="small" v-else-if="CurrentDetailsRespVo.trProtest === 1">{{this.$t('initTradeRecordPage.okRefusalPayment')}}</el-tag>
            <span v-else>{{ CurrentDetailsRespVo.trProtest || $t('unknownStatus') }}</span>
          </el-descriptions-item>

          <!--       拒付金额   -->
          <el-descriptions-item :label="$t('initTradeRecordPage.protestamout')">{{ CurrentDetailsRespVo.trProtestAmount }}</el-descriptions-item>
          <!--      冻结状态    -->
          <el-descriptions-item :label="$t('initTradeRecordPage.freezeState')">
            <!--            {{ CurrentDetailsRespVo.trCongeal }}-->
            <el-tag  size="small" v-if="CurrentDetailsRespVo.trCongeal === 0">{{this.$t('initTradeRecordPage.freezeState1')}}</el-tag>
            <el-tag  size="small" v-else-if="CurrentDetailsRespVo.trCongeal === 1">{{this.$t('initTradeRecordPage.freezeState2')}}</el-tag>
            <span v-else>{{ CurrentDetailsRespVo.trCongeal || $t('unknownStatus') }}</span>
          </el-descriptions-item>

          <!--        冻结金额  -->
          <el-descriptions-item :label="$t('initTradeRecordPage.congealamout')" >{{ CurrentDetailsRespVo.trCongealAmount }}</el-descriptions-item>
          <!--          <el-descriptions-item label=""></el-descriptions-item>-->



          <el-descriptions-item :span="2" label="" class-name="section-title-row">
            <div class="section-title">
              <!--              收件人信息-->
              {{$t('initTradeRecordPage.orderinfo')}}
            </div>
          </el-descriptions-item>

          <el-descriptions-item :label="$t('initTradeRecordPage.custName')">{{ CurrentDetailsRespVo.custName }}</el-descriptions-item>
          <!--     退款状态     -->
          <el-descriptions-item :label="$t('initTradeRecordPage.drawbackState')">
            <el-tag  size="small" v-if="CurrentDetailsRespVo.trRefundment === 0">{{this.$t('initTradeRecordPage.noDrawback')}}</el-tag>
            <el-tag  size="small" v-else-if="CurrentDetailsRespVo.trRefundment === 1">{{this.$t('initTradeRecordPage.okDrawback')}}</el-tag>
            <span v-else>{{ CurrentDetailsRespVo.trRefundment || $t('unknownStatus') }}</span>
          </el-descriptions-item>
          <!--     客户邮箱     -->
          <el-descriptions-item :label="$t('initTradeRecordPage.custemail')">{{ CurrentDetailsRespVo.ciEmail }}</el-descriptions-item>
          <!--     拒付状态     -->
          <el-descriptions-item :label="$t('initTradeRecordPage.refusalPaymentState')">
            <el-tag  size="small" v-if="CurrentDetailsRespVo.trProtest === 0">{{this.$t('initTradeRecordPage.noRefusalPayment')}}</el-tag>
            <el-tag  size="small" v-else-if="CurrentDetailsRespVo.trProtest === 1">{{this.$t('initTradeRecordPage.okRefusalPayment')}}</el-tag>
            <span v-else>{{ CurrentDetailsRespVo.trProtest || $t('unknownStatus') }}</span>
          </el-descriptions-item>
          <!--     客户邮编     -->
          <el-descriptions-item :label="$t('initTradeRecordPage.custipcode')">{{ CurrentDetailsRespVo.ciZipcode }}</el-descriptions-item>
          <!--     冻结状态     -->
          <el-descriptions-item :label="$t('initTradeRecordPage.freezeState')">

            <el-tag  size="small" v-if="CurrentDetailsRespVo.trCongeal === 0">{{this.$t('initTradeRecordPage.freezeState1')}}</el-tag>
            <el-tag  size="small" v-else-if="CurrentDetailsRespVo.trCongeal === 1">{{this.$t('initTradeRecordPage.freezeState2')}}</el-tag>
            <span v-else>{{ CurrentDetailsRespVo.trCongeal || $t('unknownStatus') }}</span>
          </el-descriptions-item>

          <!--     客户电话     -->
          <el-descriptions-item :label="$t('initTradeRecordPage.custtel')">{{ CurrentDetailsRespVo.ciTel }}</el-descriptions-item>
          <!--    进入系统时间      -->
          <el-descriptions-item :label="$t('initTradeRecordPage.trenttime')">{{ CurrentDetailsRespVo.trPaystarttime }}</el-descriptions-item>

          <!--        地址  -->
          <el-descriptions-item :label="$t('initTradeRecordPage.ciAddress')">{{ CurrentDetailsRespVo.ciAddress }}</el-descriptions-item>
          <!--      进入支付页面时间    -->
          <el-descriptions-item :label="$t('initTradeRecordPage.entpaytime')">{{ CurrentDetailsRespVo.trPaystarttime }}</el-descriptions-item>

          <!--       城市   -->
          <el-descriptions-item :label="$t('initTradeRecordPage.ciCity')">{{ CurrentDetailsRespVo.mopIpCity }}</el-descriptions-item>
          <!--       提交支付时间   -->
          <el-descriptions-item :label="$t('initTradeRecordPage.submittime')">{{ CurrentDetailsRespVo.trPayendtime }}</el-descriptions-item>

          <!--    州      -->
          <el-descriptions-item :label="$t('initTradeRecordPage.ciState')">{{ CurrentDetailsRespVo.ciState }}</el-descriptions-item>
          <!--      交易时间    -->
          <el-descriptions-item :label="$t('initTradeRecordPage.tradeTime')">{{ CurrentDetailsRespVo.trDatetime }}</el-descriptions-item>

          <el-descriptions-item :label="$t('initTradeRecordPage.ciCountry')">{{ CurrentDetailsRespVo.ciCountry }}</el-descriptions-item>
          <!--   返回时间       -->
          <el-descriptions-item :label="$t('initTradeRecordPage.trbacktime')">{{ CurrentDetailsRespVo.trBankdatetime }}</el-descriptions-item>

          <!--    确认时间      -->
          <el-descriptions-item :label="$t('initTradeRecordPage.comfirmDate')">{{ CurrentDetailsRespVo.trAuthOpTime }}</el-descriptions-item>
          <!--     账单地址     -->
          <!--          <el-descriptions-item :label="$t('initTradeRecordPage.billaddress')">
          &lt;!&ndash;            {{ CurrentDetailsRespVo.billaddress }}&ndash;&gt;
                      <el-tag  size="small" v-if="CurrentDetailsRespVo.gwReturnbilladd === 1">{{ CurrentDetailsRespVo.billaddress }} {{this.$t('initTradeRecordPage.freezeState1')}}</el-tag>
                    </el-descriptions-item>-->
          <el-descriptions-item :label="$t('initTradeRecordPage.billaddress')">
            <el-tag v-if="CurrentDetailsRespVo.gwReturnbilladd === '1'" size="small">
              {{ CurrentDetailsRespVo.billaddress }} {{ $t('initTradeRecordPage.freezeState1') }}
            </el-tag>

          </el-descriptions-item>


          <el-descriptions-item :span="2" label="" class-name="section-title-row">
            <div class="section-title">
              <!--              收件人信息-->
              {{$t('initTradeRecordPage.shipInfo')}}
            </div>
          </el-descriptions-item>

          <!--     收件人姓名     -->
          <el-descriptions-item :label="$t('initTradeRecordPage.shipname')">{{ CurrentDetailsRespVo.ciShipfirstname }} {{ CurrentDetailsRespVo.ciShiplastname }}</el-descriptions-item>
          <!--     收件人电话     -->
          <el-descriptions-item :label="$t('initTradeRecordPage.shipphone')">{{ CurrentDetailsRespVo.ciShipphone }}</el-descriptions-item>
          <!--          收件人国家-->
          <el-descriptions-item :label="$t('initTradeRecordPage.shipcountry')">{{ CurrentDetailsRespVo.ciShipcountry }}</el-descriptions-item>
          <!--      收件人州    -->
          <el-descriptions-item :label="$t('initTradeRecordPage.shipstate')">{{ CurrentDetailsRespVo.ciShipstate }}</el-descriptions-item>
          <!--       收件人城市   -->
          <el-descriptions-item :label="$t('initTradeRecordPage.shipcity')">{{ CurrentDetailsRespVo.ciShipcity }}</el-descriptions-item>
          <!--      收件人地址    -->
          <el-descriptions-item :label="$t('initTradeRecordPage.shipaddress')">{{ CurrentDetailsRespVo.ciShipaddress }}</el-descriptions-item>
          <!--     收件人邮编     -->
          <el-descriptions-item :label="$t('initTradeRecordPage.shipzip')" :span="2">{{ CurrentDetailsRespVo.ciShipzip }}</el-descriptions-item>


          <el-descriptions-item :span="2" label="" class-name="section-title-row">
            <div class="section-title">
              <!--              风险信息-->
              {{$t('riskInformation')}}
            </div>
          </el-descriptions-item>


          <el-descriptions-item :label="$t('initTradeRecordPage.flagkuatrade')" :span="2">
            {{ CurrentDetailsRespVo.flagkuatrade == '1' ? $t('initTradeRecordPage.yes') : $t('initTradeRecordPage.no') }}
            ({{$t('initTradeRecordPage.binCountry')}}: {{ CurrentDetailsRespVo.binCountry || '-' }},
            {{$t('initTradeRecordPage.ipCountry')}}: {{ CurrentDetailsRespVo.ipCountry || '-' }},
            {{$t('initTradeRecordPage.ciCountry')}}: {{ CurrentDetailsRespVo.ciCountry || '-' }})
          </el-descriptions-item>

          <!--     高风险国家     -->
          <el-descriptions-item :label="$t('initTradeRecordPage.highriskcountry')" :span="2">{{ CurrentDetailsRespVo.mopHighriskcountry }}</el-descriptions-item>

          <el-descriptions-item :label="$t('initTradeRecordPage.ipcountryinfo')" :span="2">
            <!--            跨国支付：{{ CurrentDetailsRespVo.flagkuatrade == '1' ? $t('initTradeRecordPage.yes') : $t('initTradeRecordPage.no') }}-->
            ({{$t('initTradeRecordPage.ciCountry')}}: {{ CurrentDetailsRespVo.mopCountrycode || '-' }},
            {{$t('initTradeRecordPage.ciCity')}}: {{ CurrentDetailsRespVo.mopIpCity || '-' }})
          </el-descriptions-item>

        </el-descriptions>
      </div>


    </el-drawer>



  </div>
</template>

<script>
import { hasPermission } from "@/utils/permission";
export default {
  name: "OrderList",
  data() {
    return {
      MAX_DAYS: 360,
      startDatePickerOptions: {
        disabledDate: (time) => {
          const endDate = this.HistoryTraderRecordReqVo.endDate;
          if (!endDate) return false; // 未选结束时间时不限制

          const endTs = new Date(endDate).getTime();
          const minStart = endTs - this.MAX_DAYS * 24 * 3600 * 1000;

          // 禁用：晚于结束时间 OR 早于(结束时间-32天)
          return time.getTime() > endTs || time.getTime() < minStart;
        }
      },
      endDatePickerOptions: {
        disabledDate: (time) => {
          // ========== 新增：获取初始生成的结束时间作为绝对上限 ==========
          const yesterday = new Date();
          yesterday.setDate(yesterday.getDate() - 1);
          yesterday.setHours(23, 59, 59, 999);
          const initialEndTs = yesterday.getTime();
          // ============================================================

          // 超过初始结束时间 → 直接禁用（最高优先级）
          if (time.getTime() > initialEndTs) return true;

          const startDate = this.HistoryTraderRecordReqVo.startDate;
          if (!startDate) return false; // 未选开始时间时，只受上面的绝对上限限制

          const startTs = new Date(startDate).getTime();
          const maxEnd = startTs + this.MAX_DAYS * 24 * 3600 * 1000;

          // 禁用：早于开始时间 OR 晚于(开始时间+32天)
          return time.getTime() < startTs || time.getTime() > maxEnd;
        }
      },
      excelFile: null,
      uploadDialogVisible:false,
      loading: false,
      isShowCny:null,
      maIsDefault:null,
      merDisplayScb:null,
      detailVisible: false,
      currentTrNo: '',
      selectedRowId:"",
      currentRow:null,
      CurrentDetailsRespVo:[],//订单详细数据
      commonLabelStyle: {
        width: '180px',
        minWidth: '150px',
        textAlign: 'center',  // 文字居中
        wordBreak: 'break-all'
      },
      // 内容区也居中
      commonContentStyle: {
        textAlign: 'center'
      },
      columnWidths:{},
      HistoryTraderRecordReqVo: {
        time: 'GMT+08:00',
        timeRange: [],
        trNos: "",
        bankOrderNo: "",
        trMerOrderno: "",
        status: "",
        merNo: "",
        merNo1: "",
        address:"",
        ciTel:"",
        startDate: "",
        endDate: "",
        ipAddress: "",
        ciEmail: "",
        trStatus:"",
        dateType:"0",
        trCongeal:"",
        trRefundment:"",
        tradingURL:"",
        trProtest:"",
        trTsStatus:"",
        email:"",
        trRsStatus:"",
        cardSix:"",
        cardFour:"",
        trIsexplain:"",
        trAuthType:"",
        ip:"",
        trDelivery:"",
        uploaded:"",
        trGwNo:"",

        sortField: undefined,
        sortOrder: undefined,
      },
      summaryData: {
        totalAmountStr: '',   // 总交易金额
        successAmountStr: '', // 成功交易金额
        successCount: 0,      // 成功交易笔数
        reserveAmountStr: ''  // 保证金金额
      },
      // 物流
      dialogVisible: false,
      // 弹窗表单绑定的数据
      billsData: {
        tbTrNo: '',
        tbTrackingno: '',
        tbLogisticsWebsite: '',
        tbRemark: ''
      },
      moreDialogVisible: false,
      moreInput: '',          // 弹窗中的文本内容
      currentField: null,     // 当前正在编辑的字段名，
      hasSearched: false,   //  是否有进行查询
      downloadLoading:false,
      timeList: [],
      tableData: [],
      gatewayList: [],

      pagination: {
        page: 1,
        size: 10,
        total: 0,
      },
      statusMap: {
        "-2": "warning",    // 待确认 - 黄色
        "-1": "info",       // 待处理 - 蓝色
        "0": "danger",      // 失败 - 红色
        "1": "success",     // 成功 - 绿色
      },
      statusText: {
        "-2": "待确认",
        "-1": "待处理",
        "0": "失败",
        "1": "成功",
      },
    };
  },
  created() {
    // this.handleSearch(); // 初始化加载数据
    this.isShowCny = sessionStorage.getItem("isShowCny");
    this.maIsDefault = sessionStorage.getItem("maIsDefault");
    this.merDisplayScb = sessionStorage.getItem("merDisplayScb");
    // 组件创建后设置默认时间
    this.setDefaultTime(); //时间设置
    this.getTimeOptions();
    // 网关号
    this.getGatewayOptions();
  },
  mounted() {
    this.$nextTick(() => {
      this.initColumnWidths();
    });
  },
  watch:{
    '$i18n.locale'(newVal, oldVal) {
      this.getTimeOptions();
    }
  },
  methods: {
    // 金额格式化：千分位 + 强制保留两位小数
    formatMoney(value) {
      if (!value) return "0.00";

      // 使用原生的 toLocaleString 方法实现 #,##0.00 的效果
      return Number(value).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    async showDetail() {
      if (!this.currentRow) {
        this.$message.warning('请选择订单')
        return
      }
      this.currentTrNo = this.currentRow.trNo

      const params = {
        id: this.currentRow.trNo
      };

      try {
        const res = await this.$axios.get('/api/traderecord/current/info', { params });
        if(res.data.code ===0){

          const data = res.data.data;

          const isEmpty = !data ||                                          // null / undefined
              (Array.isArray(data) && data.length === 0) ||     // 空数组 []
              (typeof data === 'object' &&
                  !Array.isArray(data) &&
                  Object.keys(data).length === 0);                // 空对象 {}

          if (isEmpty) {
            this.$message.warning(this.$t('initTradeRecordPage.noData'));
            return;
          }

          this.CurrentDetailsRespVo = data;
          this.detailVisible = true
        }

      }catch (error){

      }


    },
    // 网关号
    async getGatewayOptions() {
      try {

        const res = await this.$axios.get('/api/gateway/getlist');
        if (res.data.code === 0) {

          this.gatewayList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
          this.gatewayList = [];
        }



      } catch (error) {
        console.error('获取网关下拉列表失败:', error);
      }
    },
    // 下载
    async handledownload() {
      this.downloadLoading = true;
      this.$message.info(this.$t('DownloadInfo'));
      try {

        const params = {
          time : this.HistoryTraderRecordReqVo.time || undefined,
          startDate : this.HistoryTraderRecordReqVo.startDate || undefined,
          endDate : this.HistoryTraderRecordReqVo.endDate || undefined,
          trNos : this.HistoryTraderRecordReqVo.trNos || undefined,
          trStatus : this.HistoryTraderRecordReqVo.trStatus || undefined,
          dateType : this.HistoryTraderRecordReqVo.dateType || undefined,
          trMerOrderno : this.HistoryTraderRecordReqVo.trMerOrderno || undefined,
          trCongeal : this.HistoryTraderRecordReqVo.trCongeal || undefined,
          trRefundment : this.HistoryTraderRecordReqVo.trRefundment || undefined,
          tradingURL : this.HistoryTraderRecordReqVo.tradingURL || undefined,
          trProtest : this.HistoryTraderRecordReqVo.trProtest || undefined,
          trTsStatus : this.HistoryTraderRecordReqVo.trTsStatus || undefined,
          email : this.HistoryTraderRecordReqVo.email || undefined,
          trRsStatus : this.HistoryTraderRecordReqVo.trRsStatus || undefined,
          cardSix : this.HistoryTraderRecordReqVo.cardSix || undefined,
          cardFour : this.HistoryTraderRecordReqVo.cardFour || undefined,
          trIsexplain : this.HistoryTraderRecordReqVo.trIsexplain || undefined,
          trAuthType : this.HistoryTraderRecordReqVo.trAuthType || undefined,
          ip : this.HistoryTraderRecordReqVo.ip || undefined,
          trDelivery : this.HistoryTraderRecordReqVo.trDelivery || undefined,
          uploaded : this.HistoryTraderRecordReqVo.uploaded || undefined,
          trGwNo : this.HistoryTraderRecordReqVo.trGwNo || undefined,



        };


        const res = await this.$axios.post('/api/traderecord/history/export', params, {
          responseType: 'blob'
        });

        //
        if (res.data.type === 'application/json' || (res.headers['content-type'] && res.headers['content-type'].includes('application/json'))) {
          const reader = new FileReader();
          reader.onload = () => {
            const errorData = JSON.parse(reader.result);
            this.$message.error(errorData.msg || '导出失败');
          };
          reader.readAsText(res.data);
          return;
        }

        // 构造 Blob 对象
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        });

        if (res.headers['x-export-truncated'] === 'true') {
          const original = res.headers['x-export-original-size'];
          const exported = res.headers['x-exported-size'];
          const warningText = this.$t('export_truncated_warning').replace('{exported}', exported).replace('{original}', original);
          this.$message.warning(warningText);
        }

        //从请求头 Content-Disposition 中获取文件名 (需要后端配合暴露该 Header，否则使用默认值)
        let fileName = `历史交易明细_${new Date().getTime()}.xlsx`;
        // const disposition = res.headers['content-disposition'];
        // if (disposition) {
        //   const utf8Match = /filename\*=utf-8''([^;\s]+)/i.exec(disposition);
        //   const normalMatch = /filename="?([^";\s]+)"?/i.exec(disposition);
        //
        //   if (utf8Match && utf8Match[1]) {
        //     fileName = decodeURIComponent(utf8Match[1]);
        //   } else if (normalMatch && normalMatch[1]) {
        //     try { fileName = decodeURIComponent(normalMatch[1]); }
        //     catch (e) { fileName = normalMatch[1]; }
        //   }
        // }

        // 创建隐藏的 <a> 标签实现下载
        const downloadElement = document.createElement('a');
        const href = window.URL.createObjectURL(blob); // 创建下载的链接
        downloadElement.href = href;
        downloadElement.download = fileName; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载

        // 清理资源
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href); // 释放掉blob对象

        this.$message.success(this.$t('export_success'));
      } catch (err) {
        console.error('导出Excel失败:', err);
        this.$message.error(this.$t('requestFailed'));
      } finally {
        this.downloadLoading = false;
      }
    },
    // 添加物流
    async uploadBills(){
      if (!this.selectedRowId) {
        this.$message.warning('请选择订单')
        return
      }


      this.billsData.tbTrNo = this.selectedRowId;



      // 2. 清空之前可能残留的输入框数据
      this.billsData.tbTrackingno= '';
      this.billsData.tbLogisticsWebsite= '';
      this.billsData.tbRemark= '';

      try {
        const params = {
          trNo: this.selectedRowId
        };
        const res = await this.$axios.get('/api/traderecord/bill/info', { params });
        if(res.data.code ===0){

          const data = res.data.data;

          const isEmpty = !data ||                                          // null / undefined
              (Array.isArray(data) && data.length === 0) ||     // 空数组 []
              (typeof data === 'object' &&
                  !Array.isArray(data) &&
                  Object.keys(data).length === 0);                // 空对象 {}

          if (isEmpty) {
            this.$message.warning(this.$t('initTradeRecordPage.noData'));
            return;
          }

          this.billsData = data;

          // 3. 打开弹窗
          this.dialogVisible = true;

        }
      }catch (erroe){
        this.$message.error(res.data.msg);
      }


    },
    //物流提交
    async submitUpload() {


      try {
        const params = {
          tbTrNo: this.billsData.tbTrNo,
          tbTrackingno: this.billsData.tbTrackingno,
          tbLogisticsWebsite: this.billsData.tbLogisticsWebsite,
          tbRemark: this.billsData.tbRemark
        };
        const res = await this.$axios.post('/api/traderecord/upload/bills',  params );
        if(res.data.code === 0){


          this.dialogVisible = false; // 关闭弹窗
          this.$message.success(this.$t("succeed"));
        }else {
          this.$message.error(res.data.msg);
        }


      } catch (error) {
        console.error(error);
        this.$message.error(this.$t('loginPage.serverError'));
      }
    },
    showUploadDialog() {
      this.uploadDialogVisible = true;
    },
    // 清空数据
    handleDialogClose() {
      this.excelFile = null;
      if (this.$refs.excelUpload) {
        this.$refs.excelUpload.clearFiles();
      }
    },
    // 下载模版
    async downloadTemplate(){
      try {


        const res = await this.$axios.post('/api/traderecord/downBillTemp', {}, {
          responseType: 'blob'
        });
        //
        if (res.data.type === 'application/json' || (res.headers['content-type'] && res.headers['content-type'].includes('application/json'))) {
          const reader = new FileReader();
          reader.onload = () => {
            const errorData = JSON.parse(reader.result);
            this.$message.error(errorData.msg || '导出失败');
          };
          reader.readAsText(res.data);
          return;
        }

        // 构造 Blob 对象
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        });

        //从请求头 Content-Disposition 中获取文件名 (需要后端配合暴露该 Header，否则使用默认值)
        let fileName = `物流上传模版_${new Date().getTime()}.xlsx`;


        // 创建隐藏的 <a> 标签实现下载
        const downloadElement = document.createElement('a');
        const href = window.URL.createObjectURL(blob); // 创建下载的链接
        downloadElement.href = href;
        downloadElement.download = fileName; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载

        // 清理资源
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href); // 释放掉blob对象

        this.$message.success(this.$t('export_success'));
      } catch (err) {
        console.error('导出Excel失败:', err);
        this.$message.error(this.$t('export_fail'));
      } finally {
        this.downloadLoading = false;
      }
    },

    // 选择文件
    handleFileChange(file){
      this.excelFile=file.raw;

    },
    // 文件上传
    async submitExcel(){

      if(!this.excelFile){
        this.$message.warning(this.$t('Excel'));
        return;
      }

      const formData=new FormData();

      formData.append("file",this.excelFile);

      try{

        const res=await this.$axios.post(

            "/api/traderecord/uploadExcel/bills",

            formData

        );

        if(res.data.code===0){

          this.$message.success(this.$t('succeed'));

          this.uploadDialogVisible=false;

          this.handleSearch();

        }else{

          this.$message.error(res.data.msg);

        }

      }catch(e){

        this.$message.error(this.$t('requestFailed'));

      }

    },
    hasPermission,
    //时间格式
    formatTime(isoTime) {
      if (!isoTime) return '-';

      try {
        const date = new Date(isoTime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } catch (error) {
        return isoTime; // 如果解析失败，返回原值
      }},

    setDefaultTime() {
      // 只有在当前时间为空时才设置默认值
      if (!this.HistoryTraderRecordReqVo.startDate) {
        this.HistoryTraderRecordReqVo.startDate = this.getDefaultStartTime();
      }
      if (!this.HistoryTraderRecordReqVo.endDate) {
        this.HistoryTraderRecordReqVo.endDate = this.getCurrentTime();
      }
    },
    // 获取当前时间字符串，格式：YYYY-MM-DD HH:mm:ss
    getCurrentTime() {
      // return this.formatDateTime(new Date());
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      // 设置为当天 23:59:59
      yesterday.setHours(23, 59, 59, 999);

      return this.formatDateTime(yesterday);
    },
    // 获取当前时间往前推 1 年
    getDefaultStartTime() {
      // return this.formatDateTime(new Date());
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      // 设置为当天 23:59:59
      yesterday.setHours(0, 0, 0, 0);

      return this.formatDateTime(yesterday);
    },
    // 格式化日期为 'YYYY-MM-DD HH:mm:ss'
    formatDateTime(date) {
      const pad = (num) => String(num).padStart(2, '0');
      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 查询
    handleSearch() {
      this.pagination.page = 1; // 重置页码
      this.fetchOrderList();
    },
    // 重置
    handleReset() {
      this.$refs.queryForm.resetFields();

      this.hasSearched = false;
      //this.handleSearch();
    },
    // 时区
    async getTimeOptions() {
      try {
        this.timeList=[]
        const res = await this.$axios.get('/api/unnormal/traderecord/getTime');
        if (res.data.code === 0) {

          this.timeList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
          this.timeList = [];
        }

      } catch (error) {
        console.error('获取网关下拉列表失败:', error);
      }
    },

    //处理排序
    handleSortChange({ column, prop, order }) {
      if (order) {
        this.HistoryTraderRecordReqVo.sortField = prop;
        this.HistoryTraderRecordReqVo.sortOrder = order === 'ascending' ? 'asc' : 'desc';
      } else {
        // 取消排序时，清空排序参数
        this.HistoryTraderRecordReqVo.sortField = null;
        this.HistoryTraderRecordReqVo.sortOrder = null;
      }
      this.fetchOrderList();

    },
    // 分页：每页条数变化
    handleSizeChange(val) {
      /*  this.pagination.size = val;
        this.filterData();*/
      this.pagination.size = val;
      this.pagination.page = 1; //
      this.fetchOrderList(); //
    },
    // 分页：当前页变化
    handleCurrentChange(val) {
      /* this.pagination.page = val;
       this.filterData();*/

      this.pagination.page = val;
      this.fetchOrderList(); //
    },
    // 数据绑定
    handleRadioChange(row) {
      this.currentRow = row;
      this.selectedRowId = row.trNo;
    },
    // 查询
    async fetchOrderList() {
      this.loading = true;
      try {
        const params = {
          time : this.HistoryTraderRecordReqVo.time || undefined,
          startDate : this.HistoryTraderRecordReqVo.startDate || undefined,
          endDate : this.HistoryTraderRecordReqVo.endDate || undefined,
          trNos : this.HistoryTraderRecordReqVo.trNos || undefined,
          trStatus : this.HistoryTraderRecordReqVo.trStatus || undefined,
          dateType : this.HistoryTraderRecordReqVo.dateType || undefined,
          trMerOrderno : this.HistoryTraderRecordReqVo.trMerOrderno || undefined,
          trCongeal : this.HistoryTraderRecordReqVo.trCongeal || undefined,
          trRefundment : this.HistoryTraderRecordReqVo.trRefundment || undefined,
          tradingURL : this.HistoryTraderRecordReqVo.tradingURL || undefined,
          trProtest : this.HistoryTraderRecordReqVo.trProtest || undefined,
          trTsStatus : this.HistoryTraderRecordReqVo.trTsStatus || undefined,
          email : this.HistoryTraderRecordReqVo.email || undefined,
          trRsStatus : this.HistoryTraderRecordReqVo.trRsStatus || undefined,
          cardSix : this.HistoryTraderRecordReqVo.cardSix || undefined,
          cardFour : this.HistoryTraderRecordReqVo.cardFour || undefined,
          trIsexplain : this.HistoryTraderRecordReqVo.trIsexplain || undefined,
          trAuthType : this.HistoryTraderRecordReqVo.trAuthType || undefined,
          ip : this.HistoryTraderRecordReqVo.ip || undefined,
          trDelivery : this.HistoryTraderRecordReqVo.trDelivery || undefined,
          uploaded : this.HistoryTraderRecordReqVo.uploaded || undefined,
          trGwNo : this.HistoryTraderRecordReqVo.trGwNo || undefined,


          sortField: this.HistoryTraderRecordReqVo.sortField,
          sortOrder: this.HistoryTraderRecordReqVo.sortOrder,

          page: this.pagination.page,
          limit: this.pagination.limit,
        };

        const res = await this.$axios.post('/api/traderecord/history/traderRecord',  params );

        if (res.data.code === 0) {

          this.currentRow = "";
          this.selectedRowId = "";

          const responseData = res.data.data.page;

          const rawData = res.data.data;
          this.summaryData = {
            totalAmountStr: rawData.totalAmountStr || '0.00',
            successAmountStr: rawData.successAmountStr || '0.00',
            successCount: rawData.successCount || 0,
            reserveAmountStr: rawData.reserveAmountStr || '0.00'
          };

          this.tableData = responseData.records || [];

          this.pagination.total = Number(responseData.total) || 0;
          this.pagination.page = Number(responseData.current) || this.pagination.page;
          this.pagination.limit = Number(responseData.size) || this.pagination.limit;

          if (this.pagination.total > 0) {
            this.hasSearched = true;
          }
        } else {
          this.$message.error(res.data.msg);
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (err) {
        console.error('查询订单失败:', err);
        this.$message.error(this.$t('requestFailed'));
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },
    // 下载表单提交处理
    onDownloadSubmit() {
      if (!this.hasSearched) {
        this.$message.warning('请先点击【查询】按钮，再进行下载');
        return false; // 阻止表单提交
      }

      this.$message.success('开始生成文件，请查看浏览器下载列表...');

      return true; // 允许表单提交
    },

    // 通用打开弹窗方法
    openMoreDialog(fieldName) {
      this.currentField = fieldName;
      const currentValue = this.HistoryTraderRecordReqVo[fieldName] || '';
      // 直接显示原始内容（可能含逗号、空格等）
      this.moreInput = currentValue;
      this.moreDialogVisible = true;
    },

    /* confirmMoreInput() {
       this.queryParams[this.currentField] = this.moreInput; // ✅ 完全原样保存
       this.closeMoreDialog();
     },*/
    confirmMoreInput() {
      // 只需要去掉 # 前后的空格，保留值内部的其他空格
      const cleanedValue = this.moreInput
          .split(',')
          .map(item => item.trim())  // 去掉每个值的前后空格
          .filter(item => item.length > 0)  // 过滤空值
          .join(',');  // 用 # 重新连接

      this.HistoryTraderRecordReqVo[this.currentField] = cleanedValue;
      this.closeMoreDialog();

      if (cleanedValue) {
        //this.$message.success(`已设置 ${cleanedValue.split(',').length} 个值`);

      }
    },

    closeMoreDialog() {
      this.moreDialogVisible = false;
      this.currentField = null;
      this.moreInput = '';
    },

    onMoreDialogClose() {
      this.closeMoreDialog();
    },
    // 表头宽度
    initColumnWidths() {
      const cols = [
        "tradeMoney",
        "cny_amout",
        "protectMoney",
        "paymentState",
        "backinfo",
        "appropriationState",
        "trRsStatus",
        "isOrNotDrawback",
        "refualamout",
        "protestamout",
        "isOrNotFreeze",
        "congealamout",
        "trIsexplain",
        "uploaded",
        "Pre_authorization",
        "tradeTime",
        "comfirmDate",
        "email",
        "ipAddress",
        "ciIssuingbank",
        "whetherRedirect",


      ];
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      ctx.font = '14px Helvetica';

      cols.forEach(key => {
        const label = this.$t(
            `initTradeRecordPage.${key}`
        );

        this.$set(
            this.columnWidths,
            key,
            Math.ceil(ctx.measureText(label).width) + 50
        );
      });
    }

  },
};
</script>

<style>
/* 全局样式 - 表头居中 */
.el-table th .cell {
  white-space: nowrap !important;
  text-align: center !important;
}

.el-table .cell {
  white-space: nowrap !important;
  text-align: center !important;
}
/*隐藏此刻*/
.no-now-btn .el-picker-panel__link-btn.el-button--text {
  display: none;
}
</style>

<style scoped>
.order-list {
  padding: 20px;
}
/* 按钮独占一行 */
.btn-row {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-row .el-button + .el-button {
  margin-left: 10px;
}

/* 按钮 */
.btn-row .el-button {
  font-weight: 700;
  font-size: 14px;
  padding: 10px 24px;
  border-radius: 6px;
  min-width: 80px;
}
/* 三列铺满整个卡片 */
.query-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  /*column-gap: 80px;*/
  column-gap: clamp(24px, 5vw, 80px);
  row-gap: 0;
  width: 100%;
}

/* 让 grid 子项独占一整行 */
.query-grid > .full-row {
  grid-column: 1 / -1; /* 从第1列到最后一列 */
}
/* 确保输入框、下拉框、时间选择器在栅格中占满 100% 宽度 */
.full-width {
  width: 100% !important;
}

/* 使用 Flex 布局优雅处理 输入框 + More 按钮 的组合 */
.input-with-more {
  display: flex;
  align-items: center;
  width: 100%;
}

.input-with-more .el-input {
  flex: 1; /* 让输入框自动撑满剩余空间 */
}

.input-with-more .el-button {
  margin-left: 10px; /* 按钮和输入框之间的间距 */
  flex-shrink: 0; /* 防止按钮被挤压变形 */
}

/* 防止日期行变形 用flex */
.el-form--inline .el-form-item {
  display: flex !important;
  align-items: center; /* 垂直居中 */
}
.el-form--inline .el-form-item {
  margin-right: 0 !important;
}


/* 保持表格原有样式不变 */
.table-card ::v-deep .el-table .cell {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.table-card ::v-deep .el-table th .cell {
  white-space: nowrap !important;
}
.table-card {
  overflow-x: auto;
}
.table-card ::v-deep .el-table {
  min-width: 100%;
}
/* 防止标签文字在空间被压缩时换行，保持表单高度一致 */
.query-card ::v-deep .el-form-item__label {
  white-space: nowrap;
}

/* 操作工具栏样式 */
.action-toolbar {
  margin-top: 16px;     /* 与上方查询卡片拉开间距 */
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* 按钮之间的间距调整 */
.action-toolbar .el-button {
  margin-left: 10px;
  margin-right: 0;
}

/*中间层样式*/
.summary-container {
  margin: 15px 0;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.summary-card {
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  padding: 12px 15px;
  margin-bottom: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.card-label {
  font-size: 13px;
  color: #909399;
  margin-bottom: 6px;
  font-weight: bold;
}

.card-value {
  font-size: 18px;
  color: #303133;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

/* 人民币特殊复合布局 */
.sub-value {
  font-size: 14px;
  margin-left: 5px;
}

/* 颜色还原原项目的红绿状态 */
.text-success {
  color: #67C23A; /* ElementUI 经典的绿色 */
  font-weight: bold;
}

.text-danger {
  color: #F56C6C; /* ElementUI 经典的红色 */
  font-weight: bold;
}

/*详细数据样式*/
/*::v-deep .section-divider {
  background-color: #f5f7fa !important; !* 跟表头的浅灰色背景一致 *!
  border-top: 2px solid #e4e7ed !important; !* 加粗一点上边框作为分割 *!
  text-align: left !important; !* 标题靠左对齐更好看 *!
  padding-left: 20px !important;
}*/


::v-deep .el-descriptions__body table tr:has(.section-divider){
  display:flex;
  width:100%;
}
::v-deep .el-descriptions__body table tr:has(.section-divider) th.section-divider{
  flex:1;
  display:flex;
  justify-content:center;
  align-items:center;

  background:#f5f7fa;
  padding:14px 0;

  border-top:2px solid #ebeef5;
}
::v-deep .el-descriptions__body table tr:has(.section-divider) td.section-divider{
  display:none;
}

::v-deep .section-title-row .el-descriptions-item__content{
  text-align:center;
  font-size:16px;
  font-weight:bold;
  background:#f5f7fa;
  color:#F56C6C;

  padding:6px 0 !important;
  line-height:15px;
}

.section-title{
  font-size:18px;
  font-weight:600;
  text-align:center;
  margin:25px 0 15px;
  color:#303133;
}

.risk-title{
  color:#F56C6C;
}


/* --- 修改 1：美化查询表单的标签字体 --- */
.query-card /deep/ .el-form-item__label {
  white-space: nowrap !important;
  font-weight: 600 !important; /* 强制加粗生效 */
  color: #303133 !important; /* 强制颜色深灰生效 */
  font-size: 14px !important;
  letter-spacing: 0.5px !important;
  min-width: 140px;
  text-align: right;
}

/* --- 修改 2：美化输入框内的字体和边框 --- */
.query-card /deep/ .el-input__inner {
  font-weight: 500 !important; /* 强制生效 */
  color: #606266 !important; /* 强制生效 */
  border-radius: 6px !important; /* 强制微圆角生效 */
}

/*物流*/
.upload-dialog ::v-deep .el-dialog {
  border-radius: 10px;
}

.upload-dialog ::v-deep .el-dialog__header {
  border-bottom: 1px solid #ebeef5;
  padding: 18px 25px;
}

.upload-dialog ::v-deep .el-dialog__title {
  font-size: 18px;
  font-weight: 600;
}

.upload-dialog ::v-deep .el-dialog__body {
  padding: 35px 60px 20px;
}

/* 整个表单居中 */
.upload-form {
  width: 460px;
  margin: 0 auto;
}

/* 每一项间距 */
.upload-form .el-form-item {
  margin-bottom: 24px;
}

/* 输入框统一高度 */
.upload-form .el-input,
.upload-form .el-textarea {
  width: 100%;
}

/* 订单号 */
.order-no {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

/* 底部按钮 */
.upload-dialog ::v-deep .el-dialog__footer {
  text-align: center;
  padding: 15px 0 25px;
}

.dialog-footer .el-button {
  width: 90px;
}

.query-card ::v-deep .el-form-item.btn-row {
  display: flex !important;
  justify-content: center !important;
  margin-right: 0 !important; /* 抵消 inline 表单的右边距 */
}
/* 响应式 */
@media (max-width: 1200px) {
  .query-grid {
    column-gap: 30px;
  }
}

@media (max-width: 992px) {
  .query-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 576px) {
  .query-grid {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/merTradeMgr/initHistTradeRecordPage.vue